/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import MediBuddyName from "../assets/MediBuddyName.svg";
import { Link } from "react-router-dom";

export default function NavBar() {
  return (
    <div className="border-b-2 shadow-md sticky top-0 z-10 bg-white">
      <div className="h-20 flex justify-between items-center mx-5 md:mx-36">
        <a href="https://www.medibuddy.in" target="_blank" rel="noreferrer">
          <img className="w-36" src={MediBuddyName} />
        </a>
        <div className="flex space-x-3 md:space-x-6">
          <Link to="/">Home</Link>
          <a
            href="https://www.medibuddy.in/aboutus/"
            target="_blank"
            rel="noreferrer"
          >
            About us
          </a>
          {/* <Link to="/signup">Sign up</Link> */}
        </div>
      </div>
    </div>
  );
}
